module.exports = __webpack_public_path__ + "img/ennetix-setting-page-reports-tab.f852add8.png";